/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import axios from "axios";
import { JSON_CONTENT_TYPE } from "../../config/api";

const useVerifyToken = (token: string, location: any, isAuthenticated: boolean) => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState("");
    const [loading, setloading] = useState(true);
    const urlAuth = process.env.REACT_APP_AUTH_SERVICE;
    const url = `${urlAuth}/verify-token`;

    const fetchData = () => {
        axios
            .post(
                url,
                {
                    token,
                },
                JSON_CONTENT_TYPE
            )
            .then((res) => {
                setResponse(res.data);
            })
            .catch((err) => {
                setError(err);
            })
            .finally(() => {
                setloading(false);
            });
    };

    useEffect(() => {
        if (isAuthenticated)
            fetchData();
    }, [location]);


    // custom hook returns value
    return { response, error, loading };
};

export default useVerifyToken;
